import { NavLink } from "react-router-dom";

const VIEWS = [
  { to: "/navigate", label: "Family navigator" },
  { to: "/live", label: "Live view" },
  { to: "/gallery", label: "Gallery" },
  { to: "/whats-new", label: "What's new" },
] as const;

/** Four ways to look around. The family navigator is the main route; the gallery is the optional second view. */
export function ViewSwitch() {
  return (
    <nav aria-label="Ways to look around" className="nv-views">
      <ul>
        {VIEWS.map((view) => (
          <li key={view.to}>
            <NavLink to={view.to} end>
              {view.label}
            </NavLink>
          </li>
        ))}
      </ul>
    </nav>
  );
}
